module.exports = __webpack_public_path__ + "static/media/crevada.6f723d10.pdf";